<template>
    <transition name="grid-item-slide">
        <div class="grid-item" v-show="active">
            <slot></slot>
        </div>
    </transition>
</template>

<script>
import {ref} from 'vue';
export default {

  setup(){
    const active = ref(true);

    return {active}
  }
}
</script>
